class ReviewDetailDelegate {
    setCreateTicketModalOpen(open) {
        this.setState({ createTicketModalOpen: open });
    }

    setTicketSubmitting(v) {
        this.setState({ ticketSubmitting: v });
    }

    setNewTicketSubject(v) {
        this.setState({ newTicketSubject: v });
    }

    setNewTicketBody(v) {
        this.setState({ newTicketBody: v });
    }

    setNewTicketAttachments(v) {
        this.setState({ newTicketAttachments: v });
    }

    setNewTicketCategory(v) {
        this.setState({ newTicketCategory: v });
    }

    setNewTicketPriority(v) {
        this.setState({ newTicketPriority: v });
    }
}

export default ReviewDetailDelegate;
